import type { StoryBlokComponentProps } from 'util/storyblok/types/component.types';
import type { ServicePowerSlideBlokData } from './service-power-slide/ServicePowerSlide.data';

export type AnimalType = ('kitsune' | 'dragon' | 'koi' | 'crane')[number];

export type ServicePowerConfig = {
  path?: string;
  foregroundColor: string;
  animalColor: string;
  backgroundColor: string;
};
// export const servicePowerConfig: { [key in AnimalType]: ServicePowerConfig } = {
//   kitsune: {
//     path: 'path/to/model?',
//     foregroundColor: '#fff',
//     animalColor: '#FFFFFF',
//     backgroundColor: '#1F4037',
//   },
//   dragon: {
//     path: 'path/to/model?',
//     foregroundColor: '#fff',
//     animalColor: '#FFFFFF',
//     backgroundColor: '#232323',
//   },
//   koi: {
//     path: 'path/to/model?',
//     foregroundColor: '#fff',
//     animalColor: '#FFFFFF',
//     backgroundColor: '#E8A9A8',
//   },
//   crane: {
//     path: 'path/to/model?',
//     foregroundColor: '#000',
//     animalColor: '#FFFFFF',
//     backgroundColor: '#F8F0E4',
//   },
// };
// export const servicePowerConfig: { [key in AnimalType]: ServicePowerConfig } = {
//   kitsune: {
//     path: 'path/to/model?',
//     foregroundColor: '#fff',
//     animalColor: '#1F4037',
//     backgroundColor: '#1F4037',
//   },
//   dragon: {
//     path: 'path/to/model?',
//     foregroundColor: '#fff',
//     animalColor: '#F8F0E4',
//     backgroundColor: '#232323',
//   },
//   koi: {
//     path: 'path/to/model?',
//     foregroundColor: '#fff',
//     animalColor: '#D88684',
//     backgroundColor: '#E8A9A8',
//   },
//   crane: {
//     path: 'path/to/model?',
//     foregroundColor: '#000',
//     animalColor: '#F8F0E4',
//     backgroundColor: '#F8F0E4',
//   },
// };

export const servicePowerConfig: Record<AnimalType, ServicePowerConfig> = {
  kitsune: {
    path: 'path/to/model?',
    foregroundColor: '#fff',
    animalColor: '#ECE7C4',
    backgroundColor: '#000',
  },
  dragon: {
    path: 'path/to/model?',
    foregroundColor: '#000000',
    animalColor: '#000000',
    backgroundColor: '#fff',
  },
  koi: {
    path: 'path/to/model?',
    foregroundColor: '#fff',
    animalColor: '#ECE7C4',
    backgroundColor: '#000',
  },
  crane: {
    path: 'path/to/model?',
    foregroundColor: '#000000',
    animalColor: '#000000',
    backgroundColor: '#fff',
  },
};

export type ServicePowersRef = HTMLElement;
export type ServicePowersBlokData = {
  title?: string;
  slides: Array<ServicePowerSlideBlokData>;
};
export type ServicePowersProps = {
  blok: ServicePowersBlokData;
} & StoryBlokComponentProps;
